import React from 'react';
// import { List } from 'react-content-loader';
import Loader from '../loader/loader.component';
import './fallback.component.css';

const Fallback = ({ height }) => (
  <div style={{ height }} className="lazy-loader">
    <Loader />
  </div>
);

export default Fallback;
